const collaboration = () => {
  console.log('collaboration');
  const bio = $('[data-bio]');
  bio.click(function() {
    // bio.removeClass('is-closed');
    const id = $(this).data('bio');
    $(`#${id}`).addClass('is-open');
  });
  const bioClose = $('.bio-close');
  bioClose.click(function() {
    $(this).closest('.bio').removeClass('is-open');
    console.log('here I am');
  });
};

export default collaboration;